import { gql } from "@apollo/client";

export const deleteRewardPartnerCodeGroup = gql`
  mutation DeleteRewardPartnerCodeGroup($id: ID!) {
    deleteRewardPartnerCodeGroup(id: $id)
  }
`;
